import { Box } from '@mui/material'
import Link from 'next/link'
import { Typography } from '@evocolabs/orkaui'

const AccessoryPackage = () => {
  return (
    <Box
      sx={{
        marginTop: '24px',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px'
      }}
    >
      <Typography variant="subtitle1">What comes with your order:</Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          gap: { xs: '8px', md: '16px' },
          border: '1px solid var(--gray-200, #E5E4E3)',
          borderRadius: '12px',
          padding: '16px'
        }}
      >
        <img
          src="https://d2mhexn86y1lr4.cloudfront.net/website/product/orkaTwo/orkaCare.jpg"
          width={120}
          height={120}
          style={{
            borderRadius: '8px'
          }}
        />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '4px'
          }}
        >
          <Typography variant="subtitle1">
            Free Lifetime Care Service
          </Typography>
          <ul style={{ margin: '0px', paddingLeft: '16px' }}>
            <Typography variant="body3" as="li">
              Unlimited consultations with professionals & personalized hearing
              insights
            </Typography>
            <Typography variant="body3" as="li">
              Free complementary Orka Health App
            </Typography>
          </ul>
          <Link href="/OrkaCare" target="__blank">
            <Typography variant="Link" width="fit-content">
              Explore More
            </Typography>
          </Link>
        </Box>
      </Box>
    </Box>
  )
}

export default AccessoryPackage
